import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCth3vC_b4xT6cE6yBrjjyJaBTfYf7A_pA",
  authDomain: "materiales-byb-49a93.firebaseapp.com",
  projectId: "materiales-byb-49a93",
  storageBucket: "materiales-byb-49a93.firebasestorage.app",
  messagingSenderId: "552671827315",
  appId: "1:552671827315:web:48e95eaebe9197c585e106"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);